import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-4 9H6V9h12v11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
})), 'MuseumOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MuseumOutlined.js
// module id = 4957
// module chunks = 2